import { render, staticRenderFns } from "./AboutusCardOne.vue?vue&type=template&id=522a71fd&scoped=true&"
import script from "./AboutusCardOne.vue?vue&type=script&lang=js&"
export * from "./AboutusCardOne.vue?vue&type=script&lang=js&"
import style0 from "./AboutusCardOne.vue?vue&type=style&index=0&id=522a71fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a71fd",
  null
  
)

export default component.exports